import { useQuery } from "@tanstack/react-query"
import { ChevronDown } from "lucide-react"

import { getLocations } from "@/api/getLocations.ts"

import { Button } from "./ui/button.tsx"
import {
  DropdownMenu,
  DropdownMenuCheckboxItem,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from "./ui/dropdown-menu.tsx"

export default function LocationFilter({
  selected,
  setSelected,
}: {
  selected: number[]
  setSelected: (id: number, selected: boolean) => void
}) {
  const { data, isPending } = useQuery({
    queryKey: ["locations"],
    queryFn: () => getLocations(),
  })

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" className="flex justify-center m-auto">
          Location
          <ChevronDown />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent>
        {isPending && <>Loading...</>}
        {data?.map((l) => (
          <DropdownMenuCheckboxItem
            checked={selected.includes(l.id)}
            onCheckedChange={(s) => setSelected(l.id, s)}
          >
            {l.name}
          </DropdownMenuCheckboxItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
